import React from "react";

import { LogUnionRowItem } from "@common/components/MasterTable/models/MasterTableModel";
import { BaseCell } from "@common/components/ShakeTable/ui/BaseCell";
import { LogType } from "@common/models/eventTracking";
import { vars } from "@common/styles";
import { CellContext } from "@tanstack/react-table";

interface DomainCellProps {
  // eslint-disable-next-line
  info: CellContext<LogUnionRowItem, any>;
}

const DomainCell = ({ info }: DomainCellProps) => {
  const item = info.row.original;
  if (!item) return null;

  const isError = isCellError(info);

  return (
    <BaseCell
      style={getActivityHistoryCellStyle(isError)}
      withBorder={info.table.getSelectedRowModel()?.rows[0]?.index - 1 === info.row.index || info.row.getIsSelected()}
    >
      {info.row.original.instance_type === LogType.NETWORK_REQUEST ? parseDomainFromUrl(info.row.original.url) : ""}
    </BaseCell>
  );
};

const parseDomainFromUrl = (url: string): string | null => {
  try {
    const urlObj = new URL(url);
    let hostname = urlObj.hostname;

    if (hostname.startsWith("www.")) {
      hostname = hostname.slice(4);
    }
    return hostname;
  } catch (e) {
    return null;
  }
};

export const getActivityHistoryCellStyle = (isError: boolean) => {
  return {
    height: "2.2rem",
    paddingTop: "0.4rem",
    paddingBottom: "0.4rem",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: isError ? vars.colors.red : vars.colors.grey30,
    fontFamily: "Roobert",
    fontWeight: "500",
    fontSize: "1.3rem",
    lineHeight: "1.8rem",
    letterSpacing: "0%",
    overflow: "visible",
  };
};

// eslint-disable-next-line
export const isCellError = (info: CellContext<LogUnionRowItem, any>): boolean => {
  return (
    info.row.original.instance_type === LogType.NETWORK_REQUEST &&
    !(info.row.original.status_code?.startsWith("2") || info.row.original.status_code?.startsWith("3"))
  );
};

export { DomainCell };
